import { gql } from "@apollo/client";

export const TECHNOLOGY_MARKET_SHARE_QUERY = gql`
  query technologyMarketShare(
    $companyFilters: CompanyFilter!
    $compareAcross: TechnologyMarketShareCompareAcross!
    $groupBy: TechnologyMarketShareGroupBy!
    $installAge: Int = 24
    $localizeInstalls: Boolean = true
    $orderBy: TechnologyMarketShareOrderBy!
    $productIds: [Int]!
    $ranges: [InputIntegerRange] = []
    $companyMatchFile: CompanyMatchFilter
  ) {
    technologyMarketShare(
      companyFilters: $companyFilters
      compareAcross: $compareAcross
      groupBy: $groupBy
      installAge: $installAge
      localizeInstalls: $localizeInstalls
      orderBy: $orderBy
      productIds: $productIds
      ranges: $ranges
      companyMatchFile: $companyMatchFile
    ) {
      dimensionX {
        ... on Industry {
          name
        }
        ... on Region {
          name
        }
        ... on Naics2012 {
          name
        }
        ... on Country {
          name
        }
        ... on IntegerRange {
          min
          max
        }
      }
      installs {
        id
        companyCount
        penetrationPercent
      }
    }
  }
`;
